<template>
  <div class="d-gallery-project">
    <div class="d-gallery-project__title">
      {{ data.name }}
    </div>
    <div class="d-gallery-project__top">
      <div class="d-gallery-project__filter">
        <d-select :data-options="data.items" v-model="currentFilter" @update:modelValue="updateSwiper"/>
      </div>
      <div class="d-gallery-project__arrows">
        <div class="d-arrows-slider">
          <button ref="prev" class="d-arrows-slider__arrow d-button _slider _prev _gallery-projects _dark">
            <span></span>
            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.9675 10.0001L6.66406 15.3035L8.17902 16.8185L14.9974 10.0001L8.17902 3.18173L6.66406 4.69668L11.9675 10.0001Z"></path>
            </svg>
          </button>
          <button ref="next" class="d-arrows-slider__arrow d-button _slider _next _gallery-projects _dark" >
            <span></span>
            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.9675 10.0001L6.66406 15.3035L8.17902 16.8185L14.9974 10.0001L8.17902 3.18173L6.66406 4.69668L11.9675 10.0001Z"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <swiper
        class="d-gallery-project__slider"
        ref="slider"
        v-bind="swiperOpts"
        @swiper="onSwiper"
        :navigation="{
              prevEl: prev,
              nextEl: next,
            }"
    >

      <swiper-slide v-for="(img, i) in images" :key="img" class="d-gallery-project__slide swiper-slide">
        <img :src="img" :data-src="img" alt="" @load="onLoadImg" @click="openGallery(images, i)">
        <d-disclaimer class="d-gallery-project__disclaimer" :text="disclaimer"/>
      </swiper-slide>
    </swiper>
    <d-popup-simple v-model="showPopup" @closed="closeGallery" :with-close="false">
      <d-object-gallery-popup v-if="openedGallery" :photos="openedGallery.items" :initial-slide="openedGallery.currentIndex" type="furnish" @close="showPopup = false"/>
    </d-popup-simple>
  </div>
</template>

<script>
import { Swiper, SwiperSlide,   } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper';
import {ref} from "vue";
import DSelect from "@components/molecules/DSelect.vue";
import DPopupSimple from "@components/molecules/DPopupSimple.vue";
import DObjectGalleryPopup from "@components/molecules/DObjectGalleryPopup.vue";
import DDisclaimer from "@components/atoms/DDisclaimer.vue";

export default {
  name: "DGalleryProjectsItem",
  components: {
    DDisclaimer,
    DSelect,
    Swiper,
    SwiperSlide,
    DPopupSimple,
    DObjectGalleryPopup
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
  },
  setup() {
    const prev = ref(null);
    const next = ref(null);
    const pagination = ref(null)
    return {
      modules: [Navigation, Pagination],
      prev,
      next,
      pagination
    };
  },
  data() {
    return {
      currentFilter: null,
      swiperInstance: null,
      swiperOpts: {
        slidesPerView: 'auto',
        spaceBetween: 24,
        lazy: true,
        lazyPreloadPrevNext: 2,
        preloadImages: false,
        breakpoints: {
          320: {
            spaceBetween: 8,
          },
          768: {
            spaceBetween: 24,
          },
          1920: {
            spaceBetween: 32,
          },
        }
      },
      showPopup: false,
      openedGallery: null,
      disclaimer: 'Визуализация проекта предварительная, возможны изменения.'
    }
  },
  computed: {
    images() {
      const currentItem = this.data?.items?.find(item => item.id === this.currentFilter)
      return currentItem.images
    }
  },
  created() {
    if (this.data && this.data.items.length) {
      this.currentFilter = this.data.items[0].value;
    }
  },
  methods: {
    onSwiper(swiper) {
      this.swiperInstance = swiper
    },
    updateSwiper() {
      this.swiperInstance.slideTo(0)
    },
    onLoadImg() {
      this.swiperInstance.updateSlides()
      this.swiperInstance.update()
    },
    openGallery(images, index) {
      console.log('images', index)
      this.openedGallery = Object.assign({}, {items: images});
      this.openedGallery.currentIndex = index;
      this.showPopup = true;
    },
    closeGallery() {
      this.showPopup = false;
      this.openedGallery = null;
    },
  }
}
</script>

<style scoped>

</style>